import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-541d3cfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-root-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "company-header-menu" }, null, -1))
const _hoisted_3 = { class: "company-root-view__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressPreloader = _resolveComponent("ProgressPreloader")!
  const _component_AuthForm = _resolveComponent("AuthForm")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_CompanyHeader = _resolveComponent("CompanyHeader")!
  const _component_Header = _resolveComponent("Header")!
  const _component_SectionMenu = _resolveComponent("SectionMenu")!
  const _component_Cover = _resolveComponent("Cover")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FastViewPanel = _resolveComponent("FastViewPanel")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ProgressPreloader, {
      "is-loading": _ctx.catalogStore.isLoadingProducts
    }, null, 8, ["is-loading"]),
    (_ctx.authStore.isAuthWindowOpened)
      ? (_openBlock(), _createBlock(_component_ModalDialog, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.authStore.toggleAuthWindow(false)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AuthForm, {
              onAuthWasSuccessed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authStore.toggleAuthWindow(false)))
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.versionStore.isOpenVersionWarning)
      ? (_openBlock(), _createBlock(_component_ModalDialog, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_Warning, {
              text: _ctx.VERSION_WARNING_MESSAGE,
              onClick: _ctx.reloadPage
            }, null, 8, ["text", "onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Cover, null, {
      default: _withCtx(() => [
        _createVNode(_component_Header, {
          "home-route": { name: 'company' },
          "logo-url": _ctx.companyStore.activeCompany?.logoUrl,
          title: _ctx.companyStore.activeCompany?.name
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompanyHeader, { pages: _ctx.pages }, null, 8, ["pages"])
          ]),
          _: 1
        }, 8, ["logo-url", "title"]),
        _createVNode(_component_SectionMenu, {
          pages: _ctx.pages,
          "has-delivery-zone": _ctx.companyStore.activeCompany.hasDeliveryZone
        }, null, 8, ["pages", "has-delivery-zone"]),
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ]),
    (
        _ctx.fastViewStore.selectedProduct &&
        _ctx.fastViewStore.selectedOption &&
        _ctx.$route.query.opened_product_id
      )
      ? (_openBlock(), _createBlock(_component_ModalDialog, {
          key: 2,
          onClose: _ctx.closeFastView
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FastViewPanel, {
              product: _ctx.fastViewStore.selectedProduct,
              option: _ctx.fastViewStore.selectedOption,
              onClose: _ctx.closeFastView
            }, null, 8, ["product", "option", "onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer, {
      "legal-documents": _ctx.companyStore.activeCompany.legalDocuments,
      "cover-url": _ctx.companyStore.activeCompany.coverUrl
    }, null, 8, ["legal-documents", "cover-url"])
  ]))
}